<div id="braintree-container" data-private>
  <div #BraintreeDropInContainer></div>
  <div *ngIf="createOnly" class="default-check form-check my-2">
    <input class="form-check-input" type="checkbox" id="default" [(ngModel)]="makeDefault" />
    <label i18n class="form-check-label" for="default">Make default card</label>
  </div>
</div>
